module.exports = __webpack_public_path__ + "img/mybusiness.68406879.svg";